/**
 * @file RequireUnlockedFeature.tsx
 * @brief Route guard — blocks when Verblizr has locked a product platform-wide.
 *
 * @details
 * Company Features toggles still allow admin oversight while a product is OFF
 * for employees. A platform kill switch is different: the product is not
 * shipped yet, so company admin routes are hidden too (09-09-2026).
 *
 * @author DES
 * @date 09-09-2026
 */

import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { FullScreenLoader } from "@/components/feedback/FullScreenLoader";
import { useCompanyFeatures, type FeatureAccess } from "./api";

export function RequireUnlockedFeature({
  feature,
  children,
  redirectTo = "/company",
}: {
  feature: keyof FeatureAccess;
  children: ReactNode;
  redirectTo?: string;
}) {
  const { data, isLoading } = useCompanyFeatures();

  if (isLoading) return <FullScreenLoader label="Getting things ready…" />;
  if (data?.platformLocks?.[feature] === true) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
